import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';

import SideBar from './components/SideBar';
import MainHeader from '../components/MainHeader/MainHeader';
import Breadcrumbs from './components/Breadcrumbs';
import CreatePartTypeModal from '../components/CreatePartTypeModal/CreatePartTypeModal';

import styles from './Layout.module.scss';

const Layout = ({
  children, header, breadcrumbs, pageTitle, subheader
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    application: {
      sidebarVisibility
    } = {}
  } = useSelector((state) => ({
    application: state.application,
  }), shallowEqual);
  const contentOffsetClassName = sidebarVisibility ? 'md:ml-[260px]' : 'md:ml-[72px]';
  const headerOffset = subheader ? '150px' : '65px';
  const mobileHeaderOffset = subheader ? '112px' : '56px';

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);

  return (
    <div className="flex flex-col bg-background-main dark:bg-background-dark h-full">
      <div className="flex flex-col">
        {header || (
          <MainHeader
            sidebarVisibility={sidebarVisibility}
            subheader={subheader}
            mobileMenuOpen={mobileMenuOpen}
            onMobileMenuToggle={() => setMobileMenuOpen((open) => !open)}
          />
        )}
        <div
          className={`${styles.content} flex flex-col transition-all duration-300 ease-out
          ${contentOffsetClassName}`}
          style={{
            '--app-header-offset': headerOffset,
            '--app-mobile-header-offset': mobileHeaderOffset
          }}
        >
          <SideBar mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />
          {mobileMenuOpen && (
            <button
              type="button"
              aria-label="Close navigation"
              className="fixed inset-0 z-[97] bg-[#0f172a]/45 md:hidden"
              onClick={() => setMobileMenuOpen(false)}
            />
          )}
          <div className="flex flex-col">
            <div className="flex flex-col">
              <div className="px-[12px] pt-[12px] md:px-[30px] md:pt-0">
                {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
                {children}
              </div>
            </div>
          </div>
        </div>
        <CreatePartTypeModal />
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  subheader: PropTypes.node,
  breadcrumbs: PropTypes.shape({}),
  pageTitle: PropTypes.string
};

Layout.defaultProps = {
  header: null,
  subheader: null,
  breadcrumbs: undefined,
  pageTitle: 'MM'
};

export default Layout;
